import { render, staticRenderFns } from "./stockIn.vue?vue&type=template&id=410d8fc5&scoped=true&"
import script from "./stockIn.vue?vue&type=script&lang=js&"
export * from "./stockIn.vue?vue&type=script&lang=js&"
import style0 from "./stockIn.vue?vue&type=style&index=0&id=410d8fc5&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "410d8fc5",
  null
  
)

export default component.exports